export default __webpack_public_path__ + "static/media/correspondent7.5c8c3966.png";